<template>
  <nav class="bg-dark p-2">
    <div class="container-fluid justify-content-center">
      <div class="navbar flex-row flex-wrap justify-content-center gap-1">
        <div class="nav-item dropdown">
          <button
            class="btn btn-outline-light dropdown-toggle"
            type="button"
            id="muscleDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false">
            {{ t('workout.focus.header') }}
          </button>
          <ul class="dropdown-menu" aria-labelledby="muscleDropdown" style="z-index: 1150;">
            <li v-for="muscle in musclesGroup" :key="muscle">
              <a class="dropdown-item" href="#" @click.prevent="selectMuscle(muscle)">
                {{ t(`workout.focus.${muscle}`) }}
              </a>
            </li>
          </ul>
        </div>

        <div class="nav-item dropdown" v-if="props.typeFileterEnabled">
          <button
            class="btn btn-outline-light dropdown-toggle"
            type="button"
            id="gymTypeDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false">
            {{ t('workout.type.header') }}
          </button>
          <ul class="dropdown-menu" aria-labelledby="gymTypeDropdown" style="z-index: 1150;">
            <li v-for="type in gymTypes" :key="type">
              <a class="dropdown-item" href="#" @click.prevent="selectGymType(type)">
                {{ t(`workout.type.${type}.name`) }}
              </a>
            </li>
          </ul>
        </div>

        <div class="nav-item" v-if="props.datePickerEnabled">
          <input
            type="date"
            class="form-control btn-outline-light"
            :value="localFilters.date"
            @input="setDate($event.target.value)" />
        </div>

        <div class="nav-item" v-if="props.datePickerEnabled">
          <input
            type="text"
            class="form-control btn-outline-light"
            :placeholder="t('workout.exercise')"
            :value="localFilters.exerciseName"
            @input="setExerciseName($event.target.value)" />
        </div>

        <div class="nav-item" v-if="props.datePickerEnabled">
          <input
            type="text"
            class="form-control btn-outline-light"
            :placeholder="t('cardio.title')"
            :value="localFilters.cardioType"
            @input="setCardioType($event.target.value)" />
        </div>

        <div class="nav-item">
          <button type="button" class="btn btn-outline-light" @click="resetFilters()">
            <font-awesome-icon icon="fa-solid fa-filter-circle-xmark" />
          </button>
        </div>
      </div>
    </div>
  </nav>

  <div class="container-fluid position-sticky top-0" style="z-index: 1050;">
    <div class="d-flex flex-wrap justify-content-center">
      <span
        class="badge bg-secondary m-1"
        v-if="localFilters.gymType"
        @click="resetFilters()"
        @keydown.enter="resetFilters()">
        {{ t(`workout.type.${localFilters.gymType}.name`) }}
      </span>
      <span
        class="badge bg-secondary m-1"
        v-if="localFilters.muscle"
        @click="resetFilters()"
        @keydown.enter="resetFilters()">
        {{ t(`workout.focus.${localFilters.muscle}`) }}
      </span>
      <span
        class="badge bg-secondary m-1"
        v-if="localFilters.date"
        @click="resetFilters()"
        @keydown.enter="resetFilters()">
        {{ localFilters.date }}
      </span>
      <span
        class="badge bg-secondary m-1"
        v-if="localFilters.exerciseName"
        @click="resetFilters()"
        @keydown.enter="resetFilters()">
        {{ localFilters.exerciseName }}
      </span>
      <span
        class="badge bg-secondary m-1"
        v-if="localFilters.cardioType"
        @click="resetFilters()"
        @keydown.enter="resetFilters()">
        {{ localFilters.cardioType }}
      </span>
    </div>
  </div>
</template>

<script setup>
import { reactive } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const emit = defineEmits(['update:filters']);

const musclesGroup = ['legs', 'biceps', 'triceps', 'back', 'chest', 'glutes', 'shoulders', 'abs'];
const gymTypes = ['recovery', 'cardio', 'hypertrophy', 'strength'];

const localFilters = reactive({
  muscle: '',
  gymType: '',
  date: '',
  exerciseName: '',
  cardioType: '',
});

const props = defineProps({
  datePickerEnabled: {
    type: Boolean,
    default: true,
  },
  typeFileterEnabled: {
    type: Boolean,
    default: true,
  },
});

function emitFilters() {
  emit('update:filters', { ...localFilters });
}

function setDate(date) {
  const year = new Date(date).getFullYear();
  if (year > 2000) {
    localFilters.date = date;
    emitFilters();
  }
}

function selectMuscle(muscle) {
  localFilters.muscle = muscle;
  emitFilters();
}

function selectGymType(type) {
  localFilters.gymType = type;
  emitFilters();
}

function setExerciseName(value) {
  localFilters.exerciseName = value;
  emitFilters();
}

function setCardioType(value) {
  localFilters.cardioType = value;
  emitFilters();
}

function resetFilters() {
  if (Object.values(localFilters).some(Boolean)) {
    Object.keys(localFilters).forEach((key) => {
      localFilters[key] = '';
    });
    emitFilters();
  }
}
</script>
